<template>
  <div class="search-core-component">
    <ym-search-input :placeholder="placeholder"
                     :value="searchKey"
                     @search="handleSearch"
                     @cancel="handleCancel"
    />
    <div v-if="!showResult"
         class="search-control-container"
    >
      <ym-search-block v-if="popular.length > 0"
                       title="大家都在搜"
      >
        <div class="popular-container">
          <ym-button v-for="(key, index) in popular"
                     :key="index"
                     class="popup-btn"
                     size="small"
                     plain
                     @click="handleClickPopularKey(key)"
          >
            {{ key }}
          </ym-button>
        </div>
      </ym-search-block>
      <ym-search-history :history="history"
                         @click="handleClickHistory"
      />
    </div>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import SearchInput from '@/components/Search/Input';
  import SearchBlock from '@/components/Search/Block';
  import SearchHistory from '@/components/Search/History';

  export default {
    name: 'SearchComponent',
    metaInfo: {},
    components: {
      'ym-search-input': SearchInput,
      'ym-search-block': SearchBlock,
      'ym-search-history': SearchHistory,
      'ym-button': Button,
    },
    data() {
      return {
        searchKey: '',
        history: '',
      };
    },
    props: {
      searchValue: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      popular: {
        type: Array,
        default() {
          return [];
        },
      },
      showResult: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      searchValue(val) {
        this.searchKey = val;
      },
    },
    methods: {
      handleSearch(key) {
        this.history = key;
        this.$emit('search', key);
      },
      handleCancel() {
        this.$emit('cancel');
      },
      handleClickPopularKey(key) {
        this.searchKey = key;
        this.history = key;
        this.$emit('search', key);
      },
      handleClickHistory(key) {
        this.searchKey = key;
        this.$emit('search', key);
      },
    },
    created() {
      this.searchKey = this.searchValue;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .search-control-container {
    padding: 0 @size-base;
  }

  .popular-container {
    margin: -@size-small -(@size-small / 2) 0;
  }

  .popup-btn {
    margin: @size-small (@size-small / 2) 0;
    border-radius: @border-radius-normal;
  }
</style>
